/**
 * This file contains all the dropdown options, values, and labels for the
 * ToolBar. They should all contain the same key as their sort function and
 * group function.
 */
import { GroupBy, TimeRange, SortBy, DropdownOption } from "./types";

// Group By
const groupBySite: DropdownOption = {
  value: GroupBy.Site,
  label: (_i18n) => "Site",
};
const groupByPriority: DropdownOption = {
  value: GroupBy.Priority,
  label: (_i18n) => "Priority",
};
const groupByRule: DropdownOption = {
  value: GroupBy.Rule,
  label: (_i18n) => "Rule",
};

// Sort By
const sortByHits: DropdownOption = {
  value: SortBy.Hits,
  label: (_i18n) => "Number of Hits",
  sub: (_i18n) => "Hits",
};
const sortByEquips: DropdownOption = {
  value: SortBy.Equips,
  label: (_i18n) => "Number of Equips",
  sub: (_i18n) => "Equips",
};
const sortByInsightsAsc: DropdownOption = {
  value: SortBy.InsightsAsc,
  label: (_i18n) => "Insight (Low-High)",
  sub: (_i18n) => "Insight (Low-High)",
};
const sortByInsightsDesc: DropdownOption = {
  value: SortBy.InsightsDesc,
  label: (_i18n) => "Insight (High-Low)",
  sub: (_i18n) => "Insight (High-Low)",
};
const sortByAlphaAsc: DropdownOption = {
  value: SortBy.AlphaAsc,
  label: (_i18n) => "Alphabetical (A-Z)",
  sub: (_i18n) => "A-Z",
};
const sortByAlphaDesc: DropdownOption = {
  value: SortBy.AlphaDesc,
  label: (_i18n) => "Alphabetical (Z-A)",
  sub: (_i18n) => "Z-A",
};

// Time Range
// TODO: i18n
const rangeOneDay: DropdownOption = {
  value: TimeRange.Last24Hours,
  label: (_i18n) => "Last 24 hours",
};
const rangeThreeDays: DropdownOption = {
  value: TimeRange.Last3Days,
  label: (_i18n) => "Last 3 days",
};
const rangeSevenDays: DropdownOption = {
  value: TimeRange.Last7Days,
  label: (_i18n) => "Last 7 days",
};
const rangeOneMonth: DropdownOption = {
  value: TimeRange.Last30Days,
  label: (_i18n) => "Last 30 days",
};

export const GROUP_BY_OPTIONS = {
  monitoring: [groupByRule, groupByPriority, groupBySite],
  insights: [groupByRule, groupByPriority, groupBySite],
};

export const SORT_BY_OPTIONS = {
  monitoring: [
    sortByHits,
    sortByEquips,
    sortByInsightsAsc,
    sortByInsightsDesc,
    sortByAlphaAsc,
    sortByAlphaDesc,
  ],
  insights: [
    sortByHits,
    sortByEquips,
    sortByInsightsAsc,
    sortByInsightsDesc,
    sortByAlphaAsc,
    sortByAlphaDesc,
  ],
};

export const TIME_RANGE_OPTIONS = {
  monitoring: [rangeOneDay, rangeThreeDays, rangeSevenDays, rangeOneMonth],
  insights: [rangeOneDay, rangeThreeDays, rangeSevenDays, rangeOneMonth],
};
